import React, { useEffect, useRef, useState } from 'react'
import { Button, makeStyles } from '@material-ui/core'
import scrollTo from 'gatsby-plugin-smoothscroll'
import { ArrowDownward } from '@material-ui/icons'
import { useIntl } from 'gatsby-plugin-intl'
import { useOnScreen } from '../utils/dom'
import LoadingSpinner from './LoadingSpinner'

const useStyles = makeStyles((theme) => ({
  buttonAnimation: {
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      background: theme.palette.background.default,
      top: 0,
      width: '150%',
      height: '100%',
      opacity: 0.2,
      left: '200%',
      transition: 'all 0.4s ease',
      transform: 'skewX(-33.75deg) translateX(-50%)',
      animation: '$buttonAnimation 1s linear 500ms',
    },
  },
  button: {
    transition: 'all 0.4s ease',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  squareButton: {
    borderRadius: 2,
    fontSize: '1rem',
    lineHeight: 1.5,
    fontWeight: 500,
    overflow: 'hidden',
    padding: theme.spacing(1, 2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      padding: theme.spacing(1.5, 2),
    },
    '& span': {
      zIndex: theme.zIndex.xRayWrapper,
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      background: theme.palette.background.default,
      top: 0,
      width: '150%',
      height: '100%',
      opacity: 0.2,
      left: '-100%',
      transition: 'all 0.4s ease',
      transform: 'skewX(-33.75deg) translateX(-50%)',
    },
    '&:hover:after': {
      left: '50%',
      top: '0',
    },
  },
  linkButton: {
    color: theme.palette.text.link,
    fontSize: '1.125rem',
    lineHeight: 1.5,
    fontWeight: 500,
    overflow: 'hidden',
    padding: theme.spacing(1, 0),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      padding: theme.spacing(1.5, 0),
    },
    '& span': {
      zIndex: theme.zIndex.xRayWrapper,
      '& > svg': {
        marginLeft: theme.spacing(1),
      },
    },
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
  buttonLoading: {
    pointerEvents: 'none',
  },
  '@keyframes buttonAnimation': {
    '0%': {
      left: '-200%',
    },
    '100%': {
      left: '200%',
    },
  },
}))
const MainMarketingButton = ({
  t,
  color,
  className,
  isButtonBackgroundAnimated,
  title,
  loading = false,
  renderAsLink = false,
  footerRef,
  ...props
}) => {
  const styles = useStyles()
  const [isAnimate, setIsAnimate] = useState(false)
  const buttonRef = useRef(null)
  const isVisible = useOnScreen(buttonRef)
  const { locale } = useIntl()

  useEffect(() => {
    if (isVisible) {
      setIsAnimate(true)
    }
  }, [isVisible])

  const buttonProps = {
    variant: 'contained',
    className: [
      styles.squareButton,
      isAnimate && isButtonBackgroundAnimated ? styles.buttonAnimation : ' ',
      className,
      styles.button,
      loading ? styles.buttonLoading : ' ',
    ].join(' '),
    color: color || 'secondary',
  }
  const linkProps = {
    variant: 'text',
    className: [
      styles.linkButton,
      isAnimate && isButtonBackgroundAnimated ? styles.buttonAnimation : ' ',
      className,
      styles.button,
      loading ? styles.buttonLoading : ' ',
    ].join(' '),
  }

  const isScrollEnabled = renderAsLink || Boolean(footerRef)

  return (
    <Button
      ref={buttonRef}
      {...(isScrollEnabled
        ? {
            onClick: () => {
              scrollTo('#footer-main')
            },
          }
        : { href: `/${locale}/#footer-main` })}
      {...(renderAsLink ? linkProps : buttonProps)}
      {...props}
    >
      {loading && <LoadingSpinner />}
      {title}
      {renderAsLink && <ArrowDownward />}
    </Button>
  )
}
export default MainMarketingButton
